import { apiCall, buildQueryParams } from "./service";
import {
  BASE_URL,
  URL_PROGRAM,
  URL_PROJECTS,
  URL_CREATE_PROJECT,
  URL_DELETE_PROJECT,
  URL_PROGRAMS,
  URL_SEARCH_CLIENT_PROGRAM,
  URL_SEARCH_PROGRAM,
  URL_PROJECT_DETAILS,
  URL_RESOURCES,
  URL_UPDATE_PROJECT,
  URL_PROJECT_RESOURCES,
  URL_DELETE_PROJECT_RESOURCES,
  URL_CREATE_PROJECT_RESOURCES,
  URL_UPDATE_PROJECT_RESOURCES,
  URL_PROJECT_FLAG,
  URL_METRIX,
  URL_HEALTH_KPI,
  URL_PORTFOLIO,
  URL_CLIENT,
  URL_PROJECT_APPENDIX,
  URL_PROJECT_APPENDICES,
  URL_PROJECT_CASHFLOW,
  URL_PROJECT_CASHFLOW_CREATE_LINE,
  URL_PROJECT_CASHFLOW_UPDATE_LINE,
  URL_PROJECT_CASHFLOW_DELETE_LINE,
  URL_PROJECT_CASHFLOW_CREATE_LINE_ITEM,
  URL_PROJECT_CASHFLOW_UPDATE_LINE_ITEM,
  URL_PROJECT_CASHFLOW_LOOKUP,
  URL_PROJECT_PURCHASE_ORDERS,
  URL_SEARCH_PROJECT_PURCHASE_ORDERS,
  URL_PROJECT_CASHFLOW_UPDATE_LINE_CHECK,
  URL_PROJECT_FINANCIAL_KPIS,
} from "./URL";

export const api = {
  projectsRequest(params) {
    const { parent, search, id, page, size } = params;
    const paginationParams = { pageNumber: page, pageSize: size };
    let url;
    
    switch (parent) {
      case "Client":
        url = `${BASE_URL}Clients/${id}/Projects`;
        break;
        
      case "Portfolio":
        url = `${BASE_URL}Portfolios/${id}/Projects`;
        break;
        
      case "Program":
        url = `${BASE_URL}Programs/${id}/Projects`;
        break;
        
      default:
        url = `${BASE_URL}Projects`;
    }
  
    if (search) {
      paginationParams.searchTerm = search;
    }

    const queryParams = new URLSearchParams(paginationParams).toString();
    const fullUrl = `${url}?${queryParams}`;
  
    return apiCall.pagination({ url: fullUrl });
  },

  createProjectRequest(params) {
    return apiCall.post({
      url: `${URL_CREATE_PROJECT}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  deleteProjectRequest(params) {
    return apiCall.delete({
      url: `${URL_DELETE_PROJECT}/${params.id}`,
      isAuthToken: true,
      params,
    });
  },

  sortProjectRequest(params) {
    if (params.parent === "Client")
      return apiCall.pagination({
        url: `${URL_PROJECTS}?pageNumber=${params.page}&pageSize=${params.size}&clientId=${params.id}&orderBy=${params.orderBy}`,
        isAuthToken: true,
        params,
      });
    if (params.parent === "Program")
      return apiCall.pagination({
        url: `${URL_PROJECTS}?pageNumber=${params.page}&pageSize=${params.size}&programId=${params.id}&orderBy=${params.orderBy}`,
        isAuthToken: true,
        params,
      });
    if (params.parent === "Portfolio")
      return apiCall.pagination({
        url: `${URL_PROJECTS}?pageNumber=${params.page}&pageSize=${params.size}&portfolioId=${params.id}&orderBy=${params.orderBy}`,
        isAuthToken: true,
        params,
      });
    if (params.parent === "Project")
      return apiCall.pagination({
        url: `${URL_PROJECTS}?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
        isAuthToken: true,
        params,
      });
  },

  getProjectTimelineDetailsRequest(params) {
    return apiCall.get({
      url: `${BASE_URL}Projects/${params.id}/TimeLine?view=${params.data.viewType}`,
    });
  },

  updateProjectFlagRequest(params) {
    return apiCall.patch({
      url: `${URL_PROJECT_FLAG}/${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  getProgramsRequest(params) {
    return apiCall.get({
      url: `${URL_PROGRAMS}${params.id}/Programs`,
      isAuthToken: true,
      params,
    });
  },

  searchClientProgramDataRequest(params) {
    return apiCall.get({
      url: `${URL_SEARCH_CLIENT_PROGRAM}${params.id}/Programs?searchterm=${params.value}`,
    });
  },

  searchProgramsDataRequest(params) {
    if (params.parent === "Client")
      return apiCall.get({
        url: `${BASE_URL}search/Programs?searchterm=${params.searchText}&clientId=${params.id}`,
      });
    if (params.parent === "Program")
      return apiCall.get({
        url: `${BASE_URL}search/Programs?searchterm=${params.searchText}`,
      });
    if (params.parent === "Portfolio")
      return apiCall.get({
        url: `${BASE_URL}search/Programs?searchterm=${params.searchText}`,
      });
    return apiCall.get({ url: `${URL_SEARCH_PROGRAM}${params.searchText}` });
  },

  searchProjectsRequest(params) {
    if (params.parent === "Client")
      return apiCall.get({
        url: `${BASE_URL}search/Projects?searchterm=${params.searchText}&clientId=${params.id}`,
      });
    if (
      params.parent === "Budget" ||
      params.parent === "Change Request" ||
      params.parent === "Risk"
    )
      return apiCall.get({
        url: `${URL_PROJECTS}?searchterm=${params.searchText}`,
      });
    if (params.parent === "Program")
      return apiCall.get({
        url: `${URL_PROGRAM}${params.id}/Projects?searchterm=${params.searchText}`,
      });
    if (params.parent === "Project")
      return apiCall.get({
        url: `${URL_PROJECTS}/${params.id}?searchterm=${params.searchText}`,
      });
    if (params.parent === "Portfolio")
      return apiCall.get({
        url: `${URL_PORTFOLIO}/${params.id}/Projects?searchterm=${params.searchText}`,
      });
    return apiCall.get({
      url: `${URL_PROJECTS}?searchterm=${params.searchText}`,
    });
  },

  getProjectDetailsRequest(params) {
    if (params.id) {
      return apiCall.get({
        url: `${URL_PROJECT_DETAILS}/${params.id}`,
        isAuthToken: true,
        params,
      });
    }
  },

  getProjectBudgetSummaryRequest(params) {
    if (params.id) {
      return apiCall.get({
        url: `${URL_PROJECT_DETAILS}/${params.id}/budget-summary`,
        isAuthToken: true,
        params,
      });
    }
  },
  getProjectProgressSummaryRequest(params) {
    if (params.id) {
      return apiCall.get({
        url: `${URL_PROJECT_DETAILS}/${params.id}/progress-summary`,
        isAuthToken: true,
        params,
      });
    }
  },
  getResourcesRequest(params) {
    return apiCall.get({ url: `${URL_RESOURCES}`, isAuthToken: true, params });
  },

  updateProjectRequest(params) {
    return apiCall.put({
      url: `${URL_UPDATE_PROJECT}/${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  ///////////////////// PROJECT RESOURCES /////////////////////

  getProjectResourcesRequest(params) {
    return apiCall.pagination({
      url: `${URL_PROJECT_RESOURCES(params.id)}?pageNumber=${
        params.page
      }&pageSize=${params.size}`,
      isAuthToken: true,
      params,
    });
  },

  sortProjectResourcesRequest(params) {
    return apiCall.pagination({
      url: `${URL_PROJECT_RESOURCES(params.id)}?pageNumber=${
        params.page
      }&pageSize=${params.size}&orderBy=${params.orderBy}`,
      isAuthToken: true,
      params,
    });
  },

  createProjectResourcesRequest(params) {
    return apiCall.post({
      url: `${URL_CREATE_PROJECT_RESOURCES}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  updateProjectResourcesRequest(params) {
    return apiCall.put({
      url: `${URL_UPDATE_PROJECT_RESOURCES}${params.id}/Users/`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  deleteProjectResourceRequest(params) {
    return apiCall.delete({
      url: `${URL_DELETE_PROJECT_RESOURCES}Projects/${params.pId}/Users/${params.uId}`,
      isAuthToken: true,
      params,
    });
  },

  ///////////////////// Health Status ////////////////////////

  metrixRequest(id) {
    return apiCall.get({ url: `${URL_PROJECTS}/${id}${URL_METRIX}` });
  },

  updateMetrixKPIRequest(params) {
    return apiCall.put({
      url: `${URL_PROJECTS}/${params.id}${URL_HEALTH_KPI}`,
      params: params.payload,
    });
  },

  statusReportRequest(params) {
    let url = `${URL_PROJECTS}/${params.id}/WSR`;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    var paylaod = {tz: timezone};

    if (params.date)
      paylaod.date = params.date;

    if(params.options)
      paylaod.options = params.options;

    return apiCall.reportPost({ url: url, params: paylaod });
  },

  confirmWsrReportRequest(params) {
    return apiCall.post({
      url: `${URL_PROJECTS}/${params.id}/WSR/confirm`,
      params: { cacheKey: params.cacheKey, period: params.period },
    });
  },

  getWsrReportsRequest(params) {
    let url = `${URL_PROJECTS}/${params.id}/WSR/reports?pageNumber=${params.pageNumber || 1}&pageSize=${params.pageSize || 10}`;
    if (params.searchTerm) url += `&searchTerm=${encodeURIComponent(params.searchTerm)}`;
    if (params.orderBy) url += `&orderBy=${encodeURIComponent(params.orderBy)}`;
    return apiCall.pagination({ url });
  },

  healthStatusFilterRequest(params) {
    return apiCall.get({
      url: `${BASE_URL}Projects/${params.id}${URL_METRIX}?date=${params.data.date}`,
    });
    // return apiCall.get({url: `${BASE_URL}/Projects/${params.id}${URL_METRIX}?current=${params.data.current}&trending=${params.data.trending}`});
  },
  getProjectAppendicesRequest(projectId) {
    return apiCall.get({ url: `${URL_PROJECT_APPENDICES(projectId)}` });
  },
  getProjectAppendixRequest(projectId, appendixId) {
    return apiCall.get({
      url: `${URL_PROJECT_APPENDIX(projectId, appendixId)}`,
    });
  },
  createProjectAppendixRequest(projectId) {
    return apiCall.post({
      url: URL_PROJECT_APPENDICES(projectId),
      isAuthToken: true,
    });
  },
  updateProjectAppendixRequest(params) {
    return apiCall.put({
      url: URL_PROJECT_APPENDIX(params.projectId, params.appendixId),
      isAuthToken: true,
      params: params.payload,
    });
  },
  deleteProjectAppendixRequest(params) {
    return apiCall.delete({
      url: URL_PROJECT_APPENDIX(params.projectId, params.appendixId),
      isAuthToken: true,
    });
  },

  getProjectCashflowRequest(projectId, year) {
    let url = `${URL_PROJECT_CASHFLOW(projectId)}`;
    if (year) url += `?y=${year}`;

    return apiCall.get({ url });
  },
  createProjectCashflowLineRequest(params) {
    return apiCall.post({
      url: URL_PROJECT_CASHFLOW_CREATE_LINE(
        params.projectId
      ),
      isAuthToken: true,
      params: params.payload,
    });
  },
  canUpdateProjectCashflowLineRequest(params) {
    return apiCall.get({
      url: URL_PROJECT_CASHFLOW_UPDATE_LINE_CHECK(
        params.projectId,
        params.lineId
      ),
      isAuthToken: true,
    });
  },
  updateProjectCashflowLineRequest(params) {
    return apiCall.put({
      url: URL_PROJECT_CASHFLOW_UPDATE_LINE(
        params.projectId,
        params.lineId
      ),
      isAuthToken: true,
      params: params.payload,
    });
  },
  deleteProjectCashflowLineRequest(params) {
    return apiCall.delete({
      url: URL_PROJECT_CASHFLOW_DELETE_LINE(
        params.projectId,
        params.lineId
      ),
      isAuthToken: true,
    });
  },
  createProjectCashflowLineItemRequest(params) {
    return apiCall.post({
      url: URL_PROJECT_CASHFLOW_CREATE_LINE_ITEM(
        params.projectId,
        params.lineId
      ),
      isAuthToken: true,
      params: params.payload,
    });
  },
  updateProjectCashflowLineItemRequest(params) {
    return apiCall.put({
      url: URL_PROJECT_CASHFLOW_UPDATE_LINE_ITEM(
        params.projectId,
        params.lineId,
        params.lineItemId
      ),
      isAuthToken: true,
      params: params.payload,
    });
  },
  getProjectCashflowLookup(projectId, params) {
    let url = `${URL_PROJECT_CASHFLOW_LOOKUP(projectId)}?${buildQueryParams(params)}`;
    return apiCall.get({ url });
  },

  getProjectFinancialKpisRequest(projectId) {
    return apiCall.get({ url: URL_PROJECT_FINANCIAL_KPIS(projectId) });
  },

  getProjectPurchaseOrders(projectId, searchTerm) {
    return apiCall.get({
      url: `${URL_SEARCH_PROJECT_PURCHASE_ORDERS(projectId)}${searchTerm}`,
    });
  },

  async fetchProjectBudgets (projectId){
    try {
      const response = await apiCall.get({
        url: `${URL_PROJECTS}/${projectId}/Budgets`,
        isAuthToken: true,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  extractCharterFromPdf(file) {
    const formData = new FormData();
    formData.append('file', file);
    
    return apiCall.filePost({
          url: `${BASE_URL}Projects/charter/extract`,
          params: formData,
        });
  },

  createCharterEntities(approval) {
    return apiCall.post({
      url: `${BASE_URL}Projects/charter/create`,
      isAuthToken: true,
      params: approval
    });
  },

  validateCharterData(data) {
    const errors = {};
    
    // Project validation
    if (!data.project?.name?.trim()) {
      errors.project = { name: 'Project name is required' };
    }
    
    // Scopes validation
    if (data.scopes?.length > 0) {
      data.scopes.forEach((scope, index) => {
        if (!scope.name?.trim()) {
          errors[`scope_${index}`] = { name: 'Scope name is required' };
        }
      });
    }
    
    // Tasks validation
    if (data.tasks?.length > 0) {
      data.tasks.forEach((task, index) => {
        if (!task.name?.trim()) {
          errors[`task_${index}`] = { name: 'Task name is required' };
        }
        if (task.progress < 0 || task.progress > 100) {
          errors[`task_${index}`] = { ...errors[`task_${index}`], progress: 'Progress must be 0-100' };
        }
      });
    }
    
    return { isValid: Object.keys(errors).length === 0, errors };
  },

  calculateScopeProgress(scopeTasks) {
    if (scopeTasks.length === 0) return 0;
    const sum = scopeTasks.reduce((acc, task) => acc + (task.progress || 0), 0);
    return Math.round(sum / scopeTasks.length);
  },

  calculateProjectProgress(scopes, tasks) {
    if (scopes.length === 0) return 0;
    const scopeProgresses = scopes.map(scope => 
      this.calculateScopeProgress(tasks.filter(t => t.scopeTempId === scope.tempId))
    );
    const sum = scopeProgresses.reduce((acc, prog) => acc + prog, 0);
    return Math.round(sum / scopes.length);
  },

  checkDateHierarchy(project, scopes, tasks) {
    const warnings = [];
    
    scopes.forEach(scope => {
      if (scope.endDate && project.endDate && new Date(scope.endDate) > new Date(project.endDate)) {
        warnings.push(`Scope "${scope.name}" ends after project end date`);
      }
      
      const scopeTasks = tasks.filter(t => t.scopeId === scope.tempId);
      scopeTasks.forEach(task => {
        if (task.endDate && scope.endDate && new Date(task.endDate) > new Date(scope.endDate)) {
          warnings.push(`Task "${task.name}" ends after its scope end date`);
        }
      });
    });
    
    return warnings;
  },
  ganttReportRequest(id, payload) {
    return apiCall.pdfPost({
      url: `${URL_PROJECTS}/${id}/gantt-report`,
      params: payload,
    });
  },
  criticalPathReportRequest(id, payload) {
    return apiCall.pdfPost({
      url: `${URL_PROJECTS}/${id}/critical-path-report`,
      params: payload,
    });
  },

  getTeam(id) {
    return apiCall.get({url: `${URL_PROJECTS}/${id}/Detailed-Resources`});
  },
  getOrgChart(id, scope) {
    return apiCall.get({url: `${URL_PROJECTS}/${id}/OrgChart?scope=${scope}`});
  },
  GetResourceFromProject(projectId, resourceId) {
    return apiCall.get({url: `${URL_PROJECTS}/${projectId}/Resources/${resourceId}`});
  },
  AddResourceToProject(projectId, resourceId, data) {
    return apiCall.post({url: `${URL_PROJECTS}/${projectId}/Resources/${resourceId}`, params: data});
  },
  RemoveResourceFromProject(projectId, resourceId) {
    return apiCall.delete({url: `${URL_PROJECTS}/${projectId}/Resources/${resourceId}`});
  },
  UpdateResourceInProject(projectId, resourceId, data) {
    return apiCall.put({url: `${URL_PROJECTS}/${projectId}/Resources/${resourceId}`, params: data});
  }
};

export default api;
